import { memo } from 'react'

import css from './flex.module.scss'
import { IFlex } from './flex.type'


/** Контейнер гибкого макета для выравнивания. */
export default memo(({
    children, className,
    id, width, height,
    direction = 'column', gap = '0px', 
    justifyContent, alignItems, textAlign
}: IFlex) => {
    const componentStyle: React.CSSProperties = {
        width: width,
        height: height,
        gap: gap,
        textAlign: textAlign,
        flexDirection: direction,
        alignItems: alignItems,
        justifyContent: justifyContent,
    }

    return <div id={id} style={componentStyle} className={`${css.flex} ${className}`}>
        {children}
    </div>
})